import { render, staticRenderFns } from "./DraftAppsTable.vue?vue&type=template&id=1f9266d6"
import script from "./DraftAppsTable.vue?vue&type=script&lang=js"
export * from "./DraftAppsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports